<template>
  <v-data-table
    v-if="cidadeTop.length"
    :items="cidadeTop"
    :headers="headers"
    hide-details
    hide-default-footer
    disable-pagination
    :hide-default-headers="!cidadeTop.length"
    no-data-text="Não há dados para essa composição de filtros"
  >
    <template v-slot:item="{ item }">
      <tr>
        <td>{{ item['DES_CIDADE_SN'] }}</td>
        <td>{{ item['DES_ESTADO_SN'] }}</td>
        <td>{{ item['DES_PAIS'] }}</td>
        <td class="text-right">
          {{ item['NUM_CLIENTES_CADASTRADOS'] | localeString }}<mf-quick-actions v-if="item.COD_ID_CIDADE && !isPdf" v-bind="getQuickActionProps(item)" />
        </td>
        <td v-if="!isPdf" class="text-right">{{ item['PORCENTAGEM'] | abreviation | percent }}</td>
      </tr>
    </template>
  </v-data-table>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep'
import orderBy from 'lodash/orderBy'
import { criteriaGroup, personTypeCriteria, citiesCriteria } from '@/components/quick-actions/segmentationGroups.js'

export default {
  props: {
    infoCidade: {
      type: Array,
      default: () => [],
    },
    tipoPessoa: {
      type: String,
      default: '',
    },
    isPdf: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    cidadeTop() {
      const cidades = cloneDeep(this.infoCidade)
      const outros = cidades.pop()
      const arrayOrdenado = orderBy(cidades, ['NUM_CLIENTES_CADASTRADOS'], ['desc'])
      arrayOrdenado.push(outros)
      return arrayOrdenado
    },
    headers() {
      return [
        {
          text: 'Cidade',
          align: 'left',
          value: 'DES_CIDADE_SN',
        },
        {
          text: 'Estado',
          value: 'DES_ESTADO_SN',
        },
        {
          text: 'Pais',
          value: 'DES_PAIS',
        },
        {
          text: 'Clientes',
          align: 'right',
          value: 'NUM_CLIENTES_CADASTRADOS',
        },
        ...(this.isPdf
          ? []
          : [
              {
                text: '%',
                align: 'right',
                value: 'PORCENTAGEM',
              },
            ]),
      ]
    },
  },
  methods: {
    getQuickActionProps(item) {
      const segmentationGroup = (groupValues) => (quickActionFiltersCriteria) =>
        criteriaGroup([
          personTypeCriteria(this.tipoPessoa),
          citiesCriteria(groupValues),
          ...quickActionFiltersCriteria.criteria.segments,
          ...quickActionFiltersCriteria.criteria.loyalty,
          ...quickActionFiltersCriteria.criteria.clientGroups,
        ])
      return {
        key: item.COD_ID_CIDADE,
        quickActionGroupId: `city-${item.COD_ID_CIDADE}`,
        shortDescription: `Clientes da(s) cidade(s)`,
        longDescription: `Clientes da(s) cidade(s)`,
        quickActionGroup: 'citiess',
        quickActionGroupValue: [item.COD_ID_PAIS, item.COD_ID_ESTADO, item.COD_ID_CIDADE],
        segmentationGroup,
      }
    },
  },
}
</script>
